<template>
	<div class="record-remark-container">
		<div class="header">
			<h2>会员权益使用记录说明</h2>
			<p>了解您的会员权益使用规则，享受更优质的服务体验</p>
		</div>

		<div class="content-container">
			<div class="content-card">
				<h3 class="title">尊敬的会员：</h3>
				<p class="text">
					欢迎您使用楚建通平台的会员服务！为了确保您能够充分了解和有效利用您的会员权益，特此提供以下关于会员权益使用记录的详细说明：
				</p>

				<div class="section">
					<h4 class="block-title">
						<span class="icon"></span>
						会员权益概述
					</h4>
					<p class="section-text">
						楚建通平台为不同等级的会员提供了多样化的专属权益，包括但不限于特定次数的资源下载、信息推送、优先参与活动、专属客服支持等。这些权益旨在提升您的使用体验，帮助您在求职或招聘过程中获得更多优势。
					</p>
				</div>

				<div class="section">
					<h4 class="block-title">
						<span class="icon"></span>
						使用记录原则
					</h4>
					<p class="section-text">
						每次您使用平台提供的会员权益时，系统将自动记录一次使用记录。例如，若您作为高级会员享有5次免费下载简历的权益，每下载一次即记为使用一次，直至达到权益上限。
					</p>
				</div>

				<div class="section">
					<h4 class="block-title">
						<span class="icon"></span>
						记录查看方式
					</h4>
					<p class="section-text">
						您可以通过登录楚建通平台账户，在"会员中心"或"我的权益"等相关页面查看您的会员权益使用记录。这里将详细列出您已使用的权益种类、使用次数以及剩余次数，方便您随时掌握自己的权益状况。
					</p>
				</div>

				<div class="section">
					<h4 class="block-title">
						<span class="icon"></span>
						权益重置与更新
					</h4>
					<p class="section-text">
						会员权益的使用次数通常与您的会员周期相关联。在会员周期结束时，部分权益的使用次数可能会根据平台政策进行重置或更新。具体规则请参照平台发布的会员权益说明或相关公告。
					</p>
				</div>

				<div class="section">
					<h4 class="block-title">
						<span class="icon"></span>
						注意事项
					</h4>
					<p class="section-text">
						请确保在使用会员权益时遵守平台的相关规定和政策。任何滥用、刷单等不当行为都可能导致您的会员权益被限制或取消。同时，平台保留对会员权益使用记录进行核实和调整的权利。
					</p>
				</div>

				<div class="section">
					<h4 class="block-title">
						<span class="icon"></span>
						联系客服
					</h4>
					<p class="section-text">
						如果您对会员权益使用记录有任何疑问或需要帮助，请随时联系我们的客服团队。我们将竭诚为您提供解答和支持。
					</p>
				</div>

				<div class="footer-text">
					<p>
						楚建通平台致力于为您提供更加优质、便捷的服务体验。希望本说明能够帮助您更好地了解和使用您的会员权益。感谢您的支持与信任！
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 会员权益使用记录说明
	export default {
		name: 'RecordRemark',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.record-remark-container {
		padding: 20px 0;
		background-color: #f7f7f7;
		min-height: 100vh;

		.header {
			text-align: center;
			margin: 30px 0;

			h2 {
				font-size: 28px;
				color: #333;
				margin-bottom: 10px;
				font-weight: 600;
			}

			p {
				font-size: 16px;
				color: #666;
			}
		}

		.content-container {
			width: 1200px;
			margin: 0 auto;
			padding: 30px;
			background: #fff;
			border-radius: 8px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

			.content-card {
				padding: 30px;
				background: #fff;
				border-radius: 4px;

				.title {
					font-size: 18px;
					color: #333;
					margin-bottom: 20px;
					font-weight: 500;
				}

				.text {
					font-size: 16px;
					color: #666;
					line-height: 1.8;
					margin-bottom: 30px;
				}

				.section {
					margin-bottom: 30px;

					.block-title {
						font-size: 18px;
						color: #2671cb;
						margin-bottom: 15px;
						font-weight: 500;

						.icon {
							display: inline-block;
							width: 6px;
							height: 18px;
							background: #2671cb;
							margin-right: 10px;
							border-radius: 3px;
						}
					}

					.section-text {
						font-size: 16px;
						color: #666;
						line-height: 1.8;
						padding-left: 16px;
					}
				}

				.footer-text {
					margin-top: 40px;
					padding-top: 20px;
					border-top: 1px solid #eee;

					p {
						font-size: 16px;
						color: #666;
						line-height: 1.8;
						text-align: center;
					}
				}
			}
		}
	}
</style>
